<template>
  <div>
    <v-simple-table
      v-if="count"
      dense
      fixed-header
      :height="windowHeight - searchHeight- 49"
    >
      <template #default>
        <thead>
          <tr>
            <th
              v-for="field in config.columns"
              :key="field"
              style="cursor:pointer"
              @click="toggleSort(field)"
            >
              {{ label(field) }}
              <v-icon
                v-if="sortCol === field"
                small
              >
                mdi-chevron-{{ sortDesc ? 'down' : 'up' }}
              </v-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(line, i) in data.slice(0, -1)"
            :key="i"
          >
            <td
              v-for="field in config.columns"
              :key="field"
              :style="fields[field]['x-display'] === 'textarea' ? 'white-space:pre;' : ''"
            >
              <template v-if="line[field]">
                <template v-if="!fields[field].separator">
                  <a
                    v-if="fields[field]['x-refersTo'] === 'https://schema.org/WebPage'"
                    :href="(!line[field].includes('http') ? 'https://' : '') + line[field]"
                    target="_blank"
                  >{{
                    line[field] }}</a>
                  <a
                    v-else-if="fields[field]['x-refersTo'] === 'http://schema.org/DigitalDocument'"
                    :href="(!line[field].includes('http') ? (datasetUrl + '/attachments/') : '') + line[field]"
                    target="_blank"
                  >{{ line[field] }}</a>
                  <div
                    v-else-if="fields[field]['x-display'] === 'markdown'"
                    v-html="line[field]"
                  />
                  <template v-else>
                    {{ (formatField(line, fields[field]) + '') }}
                  </template>
                </template>
                <template
                  v-for="value in line[field].split(fields[field].separator).sort()"
                  v-else-if="line[field]"
                >
                  <v-chip
                    :key="value"
                    small
                    style="flex:none"
                    class="my-1 mr-1"
                  >
                    <a
                      v-if="fields[field]['x-refersTo'] === 'https://schema.org/WebPage'"
                      :href="(!line[field].includes('http') ? 'https://' : '') + line[field]"
                      target="_blank"
                    >{{ line[field] }}</a>
                    <a
                      v-else-if="fields[field]['x-refersTo'] === 'http://schema.org/DigitalDocument'"
                      :href="(!line[field].includes('http') ? (datasetUrl + '/attachments/') : '') + line[field]"
                      target="_blank"
                    >{{ line[field] }}</a>
                    <template v-else>
                      {{ (formatField({[field]: value}, fields[field]) + '') }}
                    </template>
                  </v-chip>
                </template>
              </template>
            </td>
          </tr>
          <tr v-intersect="loadMore">
            <td
              v-for="field in config.columns"
              :key="field"
              :style="fields[field]['x-display'] === 'textarea' ? 'white-space:pre;' : ''"
            >
              <template v-if="data[data.length-1][field]">
                <template v-if="!fields[field].separator">
                  <a
                    v-if="fields[field]['x-refersTo'] === 'https://schema.org/WebPage'"
                    :href="(!data[data.length-1][field].includes('http') ? 'https://' : '') + data[data.length-1][field]"
                    target="_blank"
                  >{{ data[data.length-1][field] }}</a>
                  <a
                    v-else-if="fields[field]['x-refersTo'] === 'http://schema.org/DigitalDocument'"
                    :href="(!data[data.length - 1][field].includes('http') ? (datasetUrl + '/attachments/') : '') + data[data.length-1][field]"
                    target="_blank"
                  >{{ data[data.length-1][field] }}</a>
                  <div
                    v-else-if="fields[field]['x-display'] === 'markdown'"
                    v-html="data[data.length-1][field]"
                  />
                  <template v-else>
                    {{ (formatField(data[data.length-1], fields[field]) + '') }}
                  </template>
                </template>
                <template
                  v-for="value in data[data.length-1][field].split(fields[field].separator).sort()"
                  v-else-if="data[data.length-1][field]"
                >
                  <v-chip
                    :key="value"
                    small
                    style="flex:none"
                    class="my-1 mr-1"
                  >
                    <a
                      v-if="fields[field]['x-refersTo'] === 'https://schema.org/WebPage'"
                      :href="(!line[field].includes('http') ? 'https://' : '') + line[field]"
                      target="_blank"
                    >{{ line[field] }}</a>
                    <a
                      v-else-if="fields[field]['x-refersTo'] === 'http://schema.org/DigitalDocument'"
                      :href="(!data[data.length - 1][field].includes('http') ? (datasetUrl + '/attachments/') : '') + data[data.length-1][field]"
                      target="_blank"
                    >{{ data[data.length-1][field] }}</a>
                    <template v-else>
                      {{ (formatField({[field]: value}, fields[field]) + '') }}
                    </template>
                  </v-chip>
                </template>
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatField } from '@data-fair/components-app/format/fields'

export default {
  computed: {
    ...mapState(['loading', 'data', 'count', 'sort']),
    ...mapGetters(['fields', 'config', 'datasetUrl']),
    searchHeight () {
      if (this.windowWidth >= 960) return 0
      const filters = (this.config.filters && this.config.filters.fields && this.config.filters.fields.length) || 0
      return (this.config.hideTextFilter ? 0 : 48) + filters * 48 + 12
    },
    sortCol () {
      return this.sort && (this.sort.charAt(0) === '-' ? this.sort.slice(1) : this.sort)
    },
    sortDesc () {
      return this.sort && this.sort.charAt(0) === '-'
    }
  },
  methods: {
    formatField,
    label (key) {
      const field = this.fields[key]
      return field.title || field['x-originalName'] || key
    },
    async loadMore (entries, observer, isIntersecting) {
      if (entries[0].isIntersecting) {
        const numGet = Math.max(1, entries[0].rootBounds && entries[0].intersectionRect.top ? Math.floor(entries[0].rootBounds.height / entries[0].intersectionRect.top - 1) : 1)
        for (let i = 0; i < numGet; i++) await this.$store.dispatch('refresh')
      }
    },
    toggleSort (field) {
      let sort = null
      if (!this.sort) sort = field
      else {
        if (this.sortCol !== field) sort = field
        else if (!this.sortDesc) sort = '-' + field
      }
      this.$store.commit('setAny', { sort })
      this.$store.dispatch('refresh', true)
    }
  }
}
</script>
